import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsOptional, IsUUID, Validate } from 'class-validator'
import { Transform } from 'class-transformer'
import { toStringOrUndefined } from '../../../utils/transformers.util'
import type { ValidationArguments, ValidatorConstraintInterface } from 'class-validator'
import { ValidatorConstraint } from 'class-validator'

/**
 * Validateur personnalisé : exactement un des deux (chapterId XOR lessonId) doit être fourni
 */
@ValidatorConstraint({ name: 'xorChapterLesson', async: false })
class XorChapterLessonConstraint implements ValidatorConstraintInterface {
  validate(_value: unknown, args: ValidationArguments): boolean {
    const obj = args.object as { chapterId?: string; lessonId?: string }
    const hasChapter = !!obj.chapterId
    const hasLesson = !!obj.lessonId
    return (hasChapter && !hasLesson) || (!hasChapter && hasLesson)
  }

  defaultMessage(): string {
    return 'Exactement un des deux champs (chapterId ou lessonId) doit être fourni'
  }
}

/**
 * DTO pour créer un lien ressource-chapitre ou ressource-leçon.
 * Un lien associe une ressource à un chapitre OU une leçon (XOR).
 */
export class CreateResourceLinkDto {
  @ApiPropertyOptional({
    description: 'ID du chapitre lié',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @Validate(XorChapterLessonConstraint)
  @IsOptional()
  @IsUUID('4')
  @Transform(toStringOrUndefined)
  chapterId?: string

  @ApiPropertyOptional({
    description: 'ID de la leçon liée',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  @Transform(toStringOrUndefined)
  lessonId?: string
}
